import React from "react";
import Image from "next/image";

const IndusteryUseCases = ({ industry }) => {
  return (
    <section className="bg-[#F0F7FF] py-sp-100 sm:py-sp-big my-sp-100 sm:my-sp-big">
      <div className="container px-3">
        <h3 className="text-baseBlack font-medium text-textxl sm:text-lg mb-5 text-center">
          {industry.sectionTitle}
        </h3>
        <div>
          <ul className="list-none flex flex-wrap justify-between w-full mx-auto items-start">
            {industry.industryUse.map((card) => (
              <li
                key={card.id}
                className="flex items-center mb-4 w-1/4 sm:w-full md:px-1 px-1 sm:px-0"
              >
                <div className="bg-white w-full text-left rounded-2xl py-6 px-2 min-h-[195px] sm:min-h-0 sm:py-4">
                  <div className="flex gap-1">
                  <Image
                    src={card.image}
                    width={50}
                    height={50}
                    alt={card.alt}
                    priority={true}
                  />
                  <div className="flex flex-col">
                  <p className="text-base2 font-medium text-baseBlack">
                    {card.heading}
                  </p>
                  <p className="text-base text-baseBlack hidden sm:block">{card.subHeading}</p>
                  </div>
                  </div>
                  <p className="text-base text-baseBlack mt-2 sm:hidden">{card.subHeading}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default IndusteryUseCases;
